import _classCallCheck from "/Users/katnoria/dev/workspaces/web/katnoria.com/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/katnoria/dev/workspaces/web/katnoria.com/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/katnoria/dev/workspaces/web/katnoria.com/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/katnoria/dev/workspaces/web/katnoria.com/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/katnoria/dev/workspaces/web/katnoria.com/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { duplicate } from '../../util';
import { Split } from '../split';

function isFalseOrNull(v) {
  return v === false || v === null;
}

export var AxisComponent = /*#__PURE__*/function (_Split) {
  _inherits(AxisComponent, _Split);

  var _super = _createSuper(AxisComponent);

  function AxisComponent() {
    var _this;

    var explicit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var implicit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var mainExtracted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    _classCallCheck(this, AxisComponent);

    _this = _super.call(this);
    _this.explicit = explicit;
    _this.implicit = implicit;
    _this.mainExtracted = mainExtracted;
    return _this;
  }

  _createClass(AxisComponent, [{
    key: "clone",
    value: function clone() {
      return new AxisComponent(duplicate(this.explicit), duplicate(this.implicit), this.mainExtracted);
    }
  }, {
    key: "hasAxisPart",
    value: function hasAxisPart(part) {
      // FIXME(https://github.com/vega/vega-lite/issues/2552) this method can be wrong if users use a Vega theme.
      if (part === 'axis') {
        // always has the axis container part
        return true;
      }

      if (part === 'grid' || part === 'title') {
        return !!this.get(part);
      } // Other parts are enabled by default, so they should not be false or null.


      return !isFalseOrNull(this.get(part));
    }
  }]);

  return AxisComponent;
}(Split);